<template>
  <div
    class="pcn-card"
    :class="cardClass"
    :id="id"
    :style="cardStyle"
    @click="onCardClick"
    ref="card"
  >
    <div class="pcn-card-content" :style="contentStyle">
      <div class="date-conatiner">
        {{ `${date}` }}
      </div>
      <h4 class="title product-title" v-if="title" v-html="title"></h4>
      <div
        class="text"
        v-if="text"
        v-html="text"
        :style="type === 'news' ? { maxHeight: '84px' } : {}"
      ></div>
      <div class="card-footer">
        <div class="date color-blue">
          {{ `Read more` }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { videoMixin } from "@/mixins/videoMixin";
export default {
  name: "pcn-card",
  props: {
    id: {
      type: String,
    },
    type: {
      type: String,
    },
    media: {
      type: Boolean,
    },
    borderColor: {
      type: String,
    },
    cardClass: {
      type: String,
    },
    title: {
      type: String,
    },
    text: {
      type: String,
    },
    date: {
      type: String,
    },
    timeFrom: {
      type: String,
    },
    timeTo: {
      type: String,
    },
    imageUrl: {
      type: String,
    },
    imageDescription: {
      type: String,
    },
    videoUrl: {
      type: String,
    },
    link: {
      type: String,
    },
  },
  mixins: [videoMixin],
  data() {
    return {
      mediaCardTypes: ["video", "memberPractice"],
      mediaStyle: {},
      contentStyle: {},
      mediaWidth: 0,
      mediaHeight: 0,
      cardEl: null,
    };
  },
  computed: {
    mediaCard() {
      return this.mediaCardTypes.includes(this.type);
    },
    cardStyle() {
      const style = {
        borderTopColor: "transparent",
        border: "none",
        height: "auto",
        cursor: "default",
      };
      switch (this.type) {
        case "memberPractice":
          style.cursor = "pointer";
          break;
        case "event":
          delete style.border;
          style.height = "300px";
          style.borderTopColor = "#f35022";
          break;
        case "staff":
          delete style.border;
          style.height = "300px";
          style.borderTopColor = "#715bff";
          break;
        case "minutes":
          delete style.border;
          style.height = "138px";
          style.borderTopColor = "#C0007C";
          style.cursor = "pointer";
          break;
        case "news":
          delete style.border;
          style.height = "350px";
          style.borderTopColor = "#715BFF";
          break;
        case "video":
          delete style.border;
          style.height = "350px";
          style.borderTopColor = "#07a7f0";
          break;
        case "staffMembers":
          delete style.border;
          style.height = "137px";
          style.textAlign = "center";
          style.cursor = "pointer";
          style.borderTopColor = "#715bff";
          break;
        default:
          style.height = "auto";
      }
      if (this.borderColor) {
        delete style.border;
        style.borderTopColor = this.borderColor;
      }
      return style;
    },
    scheduledTimings() {
      if (this.timeFrom && this.timeTo) {
        return `${this.timeFrom} - ${this.timeTo}`;
      }
      if (this.timeFrom) {
        return `${this.timeFrom}`;
      }
      return "";
    },
  },
  methods: {
    getStyles() {
      const card = this.$refs.card;
      const width = card.getBoundingClientRect().width;
      const height = (+width * 0.65).toFixed(0);
      this.mediaStyle = { height: `${height}px` };
      this.contentStyle = { height: `calc(100% - ${height}px)` };
      this.mediaWidth = width;
      this.mediaHeight = height;
    },
    transformDate(date) {
      return this.$date(new Date(date), "d MMM yyyy");
    },
    onCardClick() {
      console.log("click");
      if (this.type === "minutes") {
        this.$emit("download-click");
        return;
      }
      this.$emit("card-click");
    },
  },
  mounted() {
    if (!this.mediaCard) return;
    this.cardEl = this.$refs.card;
    this.getStyles();
  },
  watch: {
    type() {
      this.mediaStyle = {};
      this.contentStyle = {};
      if (!this.mediaCard) return;
      this.getStyles();
    },
  },
};
</script>
<style>
.date-conatiner {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #5c6572;
  margin-bottom: 6px;
}
.product-title {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #333;
}
</style>
